import * as types from "../actions/types/signatory.types";
import { getState, setState } from "../../utils/localStorage";

const initialState = {
    pinState: "initial",
    pinErrorMesaage: "",
    pinSuccessMsg: "",
    addSignatoryState: "initial",
    addSignatoryAccessLevel: null,
    errorAddMsg: null,
    userSignatoryData: {
        pin: "",
        cac: "",
        tax: "",
    },
    userSignatoryList: [],
    isDocsApproved: true,
    industry: "",
    role: {
        id: "",
        name: "",
    },
    additionalInfo: {
        tradingName: "",
        dateOfIncorporation: "",
        websiteUrl: "",
        street: "",
        lga: "",
        state: null,
        city: "",
        country: "",
        landmark: "",
        monthlyTurnOver: "",
        numberOfTransactionsPerMonth: "",
        isPubliclyTraded: null,
        id: "",
        industryType: "",
        accountOpeningPurpose: "",
        industryDescription: "",
        businessAge: "",
    },
    singleSignatoryData: {
        accessLevel: null,
        transactionLimitType: null,
        designation: "",
        overrideAccessLevelSingleLimit: null,
        overrideAccessLevelDailyLimit: null
    },
    updateTransactionPinState: "idle",
    getLimitState: "idle",
    generalLimitList: [],
    updateLimitState: "idle",
    deleteLimitState: "idle",
    fetchSignatoriesState: "idle",
    signatoriesList: [],
    initiatePinResetState: "idle",
    validateAndResetPinState: "idle",
    nomineeList: [],
    getNomineeListState: "idle",
    invitedNomineeList: [],
    getInvitedNomineeListState: "idle",
    nomineeEditInfo: ""
};

export const signatoryReducer = (state = initialState, action) => {
    switch (action.type) {
      case types.ADD_NEW_SIGNATORY_STARTED:
        return {
          ...state,
          addSignatoryState: "loading",
        };
      case types.ADD_NEW_SIGNATORY_SUCCEEDED:
        const { inviteeFirstName, inviteeLastName, inviteeEmail, accessLevel } = action.payload;
        const finalItemObj = {
          inviteeFirstName,
          inviteeLastName,
          inviteeEmail,
          accessLevel,
        };
        return {
          ...state,
          addSignatoryState: "success",
          userSignatoryList: [...state.userSignatoryList, finalItemObj],
        };
      case types.ADD_NEW_SIGNATORY_FAILED:
        return {
          ...state,
          addSignatoryState: "failed",
          errorAddMsg: action.payload,
        };
      case types.DELETE_SIGNATORY:
        const { id: signatoryId } = action.payload;
        return {
          ...state,
          userSignatoryList: state.userSignatoryList.filter((item) => item.id !== signatoryId),
        };
      case types.SET_INDUSTRY:
        setState({
          ...getState(),
          industry: action.payload,
        });
        return {
          ...state,
          industry: action.payload,
        };
      case types.SET_ROLE:
        return {
          ...state,
          role: {
            ...state.role,
            id: action.payload.id,
            name: action.payload.name,
          },
        };
      case types.SET_BUSINESS_DETAILS:
        return {
          ...state,
          additionalInfo: {
            ...state.additionalInfo,
            [action.payload.name]: !action.payload.name ? null : action.payload.value,
          },
        };
      case types.ADD_SHAREHOLDERS_STARTED:
        return {
          ...state,
          addShareholdersState: "loading",
        };
      case types.ADD_SHAREHOLDERS_SUCCEEDED:
        return {
          ...state,
          addShareholdersState: "success",
          shareholders: action.payload,
        };
      case types.ADD_SHAREHOLDERS_FAILED:
        return {
          ...state,
          addShareholdersState: "failed",
        };
      case types.ADD_TO_SHAREHOLDERS_SCHEMA:
        return {
          ...state,
          shareholders: [
            ...state.shareholders,
            {
              firstName: "",
              lastName: "",
              type: "",
              percentage: "",
            },
          ],
        };
      case types.SET_SIGNATORY_EDIT_INFO:
        return {
          ...state,
          singleSignatoryData: {
            ...state.singleSignatoryData,
            [action.payload.name]: !action.payload.name ? null : action.payload.value,
          },
        };
      case types.UPDATE_TRANSACTION_PIN_STARTED:
        return {
          ...state,
          updateTransactionPinState: "loading",
        };
      case types.UPDATE_TRANSACTION_PIN_SUCCEEDED:
        return {
          ...state,
          updateTransactionPinState: "success",
        };
      case types.UPDATE_TRANSACTION_PIN_FAILED:
        return {
          ...state,
          updateTransactionPinState: "failed",
        };

      case types.INITIATE_PIN_RESET_STARTED:
        return {
          ...state,
          validateAndResetPinState: "loading",
        };
      case types.INITIATE_PIN_RESET_SUCCEEDED:
        return {
          ...state,
          validateAndResetPinState: "success",
        };
      case types.INITIATE_PIN_RESET_FAILED:
        return {
          ...state,
          validateAndResetPinState: "failed",
        };
      case types.VALIDATE_RESET_PIN_STARTED:
        return {
          ...state,
          validateAndResetPinState: "loading",
        };
      case types.VALIDATE_RESET_PIN_SUCCEEDED:
        return {
          ...state,
          validateAndResetPinState: "success",
        };
      case types.VALIDATE_RESET_PIN_FAILED:
        return {
          ...state,
          validateAndResetPinState: "failed",
        };
      case types.GET_LIMIT_LIST_STARTED:
        return {
          ...state,
          getLimitState: "loading",
        };
      case types.GET_LIMIT_LIST_SUCCEEDED:
        return {
          ...state,
          getLimitState: "success",
          generalLimitList: action.payload,
        };
      case types.GET_LIMIT_LIST_FAILED:
        return {
          ...state,
          getLimitState: "failed",
        };
      case types.UPDATE_TRANSACTION_LIMIT_STARTED:
        return {
          ...state,
          updateLimitState: "loading",
        };
      case types.UPDATE_TRANSACTION_LIMIT_SUCCEEDED:
        const itemIndex = state.generalLimitList.findIndex((item) => item.id === action.payload.id);
        let updatedArr = [...state.generalLimitList];
        updatedArr[itemIndex] = {
          ...updatedArr[itemIndex],
          singleTransferAmountLimit: action.payload.singleTransferAmountLimit,
          dailyCummulativeAmountLimit: action.payload.dailyCummulativeAmountLimit,
        };
        return {
          ...state,
          updateLimitState: "success",
          generalLimitList: updatedArr,
        };
      case types.UPDATE_TRANSACTION_LIMIT_FAILED:
        return {
          ...state,
          updateLimitState: "failed",
        };
      case types.FETCH_SIGNATORIES_STARTED:
        return {
          ...state,
          fetchSignatoriesState: "loading",
        };
      case types.FETCH_SIGNATORIES_SUCEEDED:
        return {
          ...state,
          fetchSignatoriesState: "success",
          signatoriesList: action.payload,
        };
      case types.FETCH_SIGNATORIES_FAILED:
        return {
          ...state,
          fetchSignatoriesState: "failed",
        };
      case types.DELETE_SIGNATORY_STARTED:
        return {
          ...state,
          deleteLimitState: "loading",
        };
      case types.DELETE_SIGNATORY_SUCCEEDED:
        return {
          ...state,
          deleteLimitState: "success",
          signatoriesList: state.signatoriesList.filter((item) => item.id !== action.payload),
        };
      case types.DELETE_SIGNATORY_FAILED:
        return {
          ...state,
          deleteLimitState: "failed",
        };
      case types.DISABLE_SIGNATORY_STARTED:
        return {
          ...state,
          disableSignatoryState: "loading",
        };
      case types.DISABLE_SIGNATORY_SUCCEEDED:
        const itemIndx = state.signatoriesList.findIndex((item) => item.id === action.payload.id);
        let updatedArray = [...state.signatoriesList];
        updatedArray[itemIndx] = {
          ...updatedArray[itemIndx],
          signatoryStatus: action.payload.signatoryStatus,
        };
        return {
          ...state,
          signatoriesList: updatedArray,
          disableSignatoryState: "success",
        };
      case types.DISABLE_SIGNATORY_FAILED:
        return {
          ...state,
          disableSignatoryState: "failed",
        };
      case types.UPDATE_NEWSIGNATORY_SUCCEEDED:
        const newItemIndex = state.signatoriesList.findIndex((item) => item.id === action.payload.id);
        let newUpdatedArr = [...state.signatoriesList];
        newUpdatedArr[newItemIndex] = {
          ...newUpdatedArr[newItemIndex],
          firstName: action.payload.firstName,
          lastName: action.payload.lastName,
          designation: action.payload.designation,
          dateOfBirth: action.payload.dateOfBirth,
          phoneNumber: action.payload.phoneNumber,
          roleID: action.payload.roleID,
          status: action.payload.status,
          address: action.payload.address,
          id: action.payload.id,
          smeprofileid: action.payload.smeprofileid,
          userid: action.payload.userid,
          accessLevel: action.payload.accessLevel === 1 ? "Admin" : action.payload.accessLevel === 2 ? "Signatory" : action.payload.accessLevel === 3 ? "Staff" : "Staff",
          dailyCummulativeAmountLimit: action.payload.dailyCummulativeAmountLimit,
          singleTransferAmountLimit: action.payload.singleTransferAmountLimit,
          overrideAccessLevelDailyLimit: action.payload.overrideAccessLevelDailyLimit,
          overrideAccessLevelSingleLimit: action.payload.overrideAccessLevelSingleLimit,
        };
        return {
          ...state,
          updateSignatoryState: "success",
          signatoriesList: newUpdatedArr,
        };
      case types.ADD_NEW_NOMINEE_SUCCEEDED:
        return {
          ...state,
          invitedNomineeList:[
            ...state.invitedNomineeList,
            action.payload
          ]
        }

      case types.EDIT_NOMINEE_SUCCEEDED:
        return {
          ...state,
          nomineeList:action.payload

        }
      case types.SET_NOMINEE_EDIT_INFO:
        return {
          ...state,
          nomineeEditInfo: action.payload
        }
      case types.FETCH_INVITED_NOMINEES_STARTED:
        return{
          ...state,
          getInvitedNomineeListState: "loading"
        }
      case types.FETCH_INVITED_NOMINEES_SUCCEEDED:
        return {
          ...state,
          invitedNomineeList: action.payload,
          getInvitedNomineeListState: "success"
        }
      case types.FETCH_TEAMMATES_STARTED:
          return{
            ...state,
            getNomineeListState: "loading"
          }
      case types.FETCH_TEAMMATES_SUCCEEDED:
        return {
          ...state,
          nomineeList: action.payload,
          getNomineeListState: "success"
        }
      case types.DELETE_NOMINEE_SUCCEEDED:
        return {
          ...state,
          nomineeList:action.payload
        }
      default:
        return state;
    }
};
